// 韩语
module.exports = {
    public: {
        confirm: '확인',
        cancel: '취소',
        reset: '초기화',
        search: '검색',
        RefreshSucceeded: '새로고침 완료',
        noMoreData: '더 이상 데이터 없음',
        pullingText: '당겨서 새로고침…',
        ReleaseText: '놓으면 새로고침…',
        loadingText: '로딩 중…',
        noData: '기록 없음',
        copyTxt: '복사',
        copySuccess: '복사 성공',
        amount: '금액',
        buy: '구매',
        orderNo: '주문번호',
        selectLang: '언어 선택',
        light: '라이트',
        dark: '다크',
        All: '전체',
        DigitalCurrency: '디지털화폐',
        foreignExchange: '외환',
        futures: '선물',
        stockIndex: '주가지수',
        stock: '주식',
        BalanceNot: '잔액 부족',
        optional: '관심종목',
        market: '시장',
        USDTcontract: 'USDT 계약',
        Fiatcurrencycontract: '법정화폐 계약',
        spot: '현물',
        secondContract: '초 단위 계약',
        emptyTxt: '기록이 없습니다',
    },
    tabBar: {
        home: '홈',
        market: '발견',
        trade: '거래',
        heel: '재테크',
        asset: '자산',
    },
    about: {
        title: '회사소개',
        version: '버전',
        about: '소개',
        ProductIntroduction: '제품 소개',
        Termofservice: '서비스 약관',
        PrivacyAgreement: '개인정보 보호정책',
        Riskstatement: '위험 공지',
        whitePaper: '백서',
    },
    asset: {
        Overview: '개요',
        contract: '계약',
        wallet: '지갑',
        Totalassetvaluation: '총 자산 평가',
        supportswithdrawal: '입금한 모든 자산은 출금 가능',
        Recharge: '충전',
        Contractaccount: '계약 계정',
        Spotaccount: '현물 계정',
        Walletaccount: '지갑 계정',
        ValuationContractAssets: '계약 자산 평가',
        profitloss: '손익',
        Transfer: '이체',
        occupy: '잠금',
        available: '사용 가능',
        Viewallpositions: '모든 포지션 보기',
        Valuationspotassets: '현물 자산 평가',
        Hidezerobalanceassets: '0 잔액 숨기기',
        balance: '잔액',
        ValuationWalletAssets: '지갑 자산 평가',
        Withdrawal: '출금',
        Walletbalance: '지갑 잔액',
        Cryptocurrencyrecharge: '암호화폐 충전',
        Fiatcurrencyrecharge: '법정화폐 충전',
        From: '보내는 곳',
        To: '받는 곳',
        UsdtContractaccount: 'USDT 계약 계정',
        FiatContractaccount: '법정화폐 계약 계정',
        Currency: '통화',
        quantity: '수량',
        availablebalance: '사용 가능 잔액',
        Insufficientavailablebalance: '사용 가능 잔액 부족',
        Transfersuccessful: '이체 성공',
        flashcash: '빠른 교환',
        flashcashsuccessful: '빠른 교환 성공',
    },
    auth: {
        title: '본인 인증',
        gj: '국적',
        tipsgj: '국적을 선택하세요',
        userName: '실명',
        tips1: '실명을 입력하세요',
        IDNumber: '신분증 번호',
        tips2: '신분증 번호를 입력하세요',
        base: '기본 인증',
        high: '고급 인증',
        zmz: '신분증 앞면',
        bmz: '신분증 뒷면',
        tips3: '앞면을 업로드하세요',
        tips4: '뒷면을 업로드하세요',
        btn: '제출',
        upbtn: '문서 수정',
        subMsg: '제출 성공, 검토 중',
        upMsg: '수정 시 재검토 필요, 변경하시겠습니까?',
        wait: '검토 중',
        fail: '인증 실패',
        success: '인증 성공',
        cardType: '문서 유형',
        idCard: '신분증',
        passport: '여권',
        driverlicense: '운전면허증',
        AssetCertification: '자산 인증',
        AccountType: '계좌 유형',
        holdingamount: '보유 금액',
        Accountscreenshot: '계좌 스크린샷',
        bankaccount: '은행 계좌',
        IRAaccount: 'IRA 계좌',
        stockaccount: '주식 계좌',
        other: '기타',
        AccountTypetips: '계좌 유형을 선택해 주세요',
        Accountscreenshottips: '계좌 스크린샷을 업로드해 주세요',
    },
    activity: {
        toptit: '복지',
        inviteTxt: '친구 1명을 초대할 때마다 {amount} USD를 받을 수 있으며, 최대 3단계 커미션을 지원합니다',
        invitebtn: '초대 커미션',
        rechargeTxt: '하위 사용자가 충전하면 {amount}% 커미션을 받을 수 있으며, 최대 3단계 커미션을 지원합니다',
        rechargebtn: '충전 커미션',
        authTxt: '본인 인증 성공 시 {amount} USD를 즉시 지급',
        authbtn: '본인 인증',
        inviteRewardTxt: '<p><strong>친구 초대하고, 쉽게 30 USD 받기</strong></p><p><br></p><p>1. 활동 목표</p><p><br></p><p>대상 사용자: 기존 및 신규 사용자 모두 참여 가능하며, 기존 사용자가 적극적으로 친구를 초대하여 등록하고 지정된 작업을 완료하도록 장려하여 플랫폼 사용자 기반을 확대합니다.</p><p>핵심 요구: 추천 메커니즘을 통해 신규 사용자가 빠르게 입주하고 바이럴 성장을 이루며, 초대한 사람에게 실질적인 보상을 제공하여 사용자 유지 및 충성도를 강화합니다.</p><p><br></p><p>2. 활동 기간</p><p><br></p><p>2023년 5월 20일 – 장기 유효 (정기 점검 또는 종료 시 별도 공지)</p><p><br></p><p>3. 참여 대상</p><p><br></p><p>플랫폼에 등록하고 기본 실명 인증을 완료한 사용자는 모두 초대한 사람(A)이 될 수 있습니다;</p><p>초대받은 사람(B)은 초대 링크 또는 초대 코드를 통해 신규 등록 및 실명 인증을 완료해야 유효합니다.</p><p><br></p><p>4. 참여 규칙</p><p><br></p><p>초대 방법</p><p>초대한 사람(A)은 “개인 페이지” → “친구 초대” → 전용 초대 링크/초대 코드를 복사합니다.</p><p>링크/초대 코드를 친구(B)에게 공유하고 웹 또는 앱을 통해 등록하도록 합니다.</p><p><br></p><p>초대받은 사람 요구 사항</p><p>초대받은 사람(B)은 초대한 사람이 제공한 링크 또는 초대 코드를 사용하여 최초 등록을 완료해야 합니다.</p><p>등록 후 7일 내에 실명 인증을 완료하고 최소 충전 기준(예: 최초 충전 ≥ 1000 USD 또는 동등한 토큰)을 충족해야 합니다.</p><p><br></p><p>계층 구분</p><p>이 활동은 최대 3단계 커미션을 지원합니다.</p><p>1단계 (직접 초대): A가 B를 직접 초대하여 등록시</p><p>2단계: B가 C를 초대하면 A는 2단계 수익을 얻습니다.</p><p>3단계: C가 D를 초대하면 A는 3단계 수익을 얻습니다.</p><p>3단계를 초과한 초대(D가 E 및 이후)를 통한 수익은 A에게 포함되지 않습니다.</p><p><br></p><p>5. 보상 세부사항</p><p><br></p><p>1단계 초대 보상 (직접 초대)</p><p>초대받은 B가 충전 및 실명 인증을 완료하면, 초대한 A는 30 USD를 받습니다.</p><p><br></p><p>2단계 초대 보상 (간접 초대)</p><p>B가 초대한 C가 동일 조건(실명 인증 + 최소 충전)을 충족하면 A는 15 USD를 받습니다.</p><p><br></p><p>3단계 초대 보상 (재간접 초대)</p><p>C가 초대한 D가 조건을 충족하면 A는 10 USD를 받습니다.</p><p><br></p><p>보상 지급 방식</p><p>시스템이 3단계 초대 관계를 자동으로 인식하여 하위 단계(직접 또는 간접 초대)가 조건을 충족하면 <strong>48시간 내</strong>에 해당 보상을 자동으로 초대한 A의 계정 자산에 지급합니다.</p><p><br></p><p>6. 운영 예시</p><p><br></p><p>A가 cryptorix에 로그인하여 “개인 페이지” → “친구 초대” → 전용 초대 링크/초대 코드를 복사합니다.</p><p>A는 링크/초대 코드를 친구 B에게 보냅니다.</p><p>B는 링크를 클릭하거나 초대 코드를 입력하여 등록 페이지로 이동 → 이메일 등록 → 실명 인증 및 1000 USD 이상 충전을 완료합니다.</p><p>B가 실명 인증과 충전을 완료하면 온라인 고객센터에 보상을 신청할 수 있으며, 시스템 심사 통과 후 48시간 내에 A에게 30 USD 보상이 지급됩니다.</p><p>B가 C를 초대하고 C도 조건을 충족하면 시스템은 자동으로 A에게 15 USD를 지급하며, C가 D를 초대하면 D가 조건을 충족했을 때 시스템은 A에게 10 USD를 지급합니다.</p><p><br></p><p>7. 리스크 관리 및 주의사항</p><p><br></p><p>사기 방지 조치</p><p>각 전화번호/이메일은 한번만 초대 가능하며, 동일 IP, 신분증 등 다양한 차원에서 리스크 시스템이 연동하여 감지합니다.</p><p>동일 기기, 동일 네트워크 환경에서 다량의 저품질 등록 계정 행위는 백엔드에서 수동 심사를 진행하며, 필요시 보상을 취소합니다.</p><p><br></p><p>위반 처벌</p><p>초대한 사람 또는 초대받은 사람이 악의적 보상 부정행위, 현금화 행위를 할 경우 플랫폼은 관련 모든 보상을 단독으로 취소하고 계정을 동결할 권리가 있습니다.</p><p><br></p><p>&nbsp;</p>',
        rechargeRewardTxt: '<p><strong>하위 충전 커미션, 기다림 없이 수익 즐기기</strong></p><p><br></p><p><strong>1. 활동 목표</strong></p><p><br></p><p>대상 사용자: 실명 인증을 완료한 1단계 초대한 사람(A)은 하위 사용자(B, C, D)의 플랫폼 내 충전 시 플랫폼이 설정한 비율의 커미션 수익을 얻어 “바이럴 체인”을 육성하고 사용자 활동도를 높입니다.</p><p><br></p><p>핵심 요구: “충전 커미션” 메커니즘을 통해 신규 사용자의 충전 행동과 초대한 사람의 이익을 연동하여 “초대-충전-커미션 지급-재초대”의 선순환을 형성하고 플랫폼 자금 잔류 및 활동도 향상을 촉진합니다.</p><p><br></p><p><strong>2. 활동 기간</strong></p><p><br></p><p>상시 활동: 2023년 5월 20일부터 장기 유효하며, 사업 요구에 따라 커미션 비율 또는 활동 종료일이 조기 공지될 수 있습니다.</p><p><br></p><p><strong>3. 참여 대상</strong></p><p><br></p><p>초대한 사람 A: 실명 인증 완료자이며 최소 1명의 하위 사용자가 실명 인증을 완료한 경우</p><p><br></p><p>하위 사용자 B, C, D: A가 초대했거나 그 하위가 초대하여 형성된 2~3단계 사용자 체인으로, 하위 사용자가 플랫폼에서 충전할 때 A가 커미션 수익을 얻습니다.</p><p><br></p><p><strong>4. 참여 규칙</strong></p><p><br></p><p><strong>계층 관계：</strong></p><p><br></p><p>1단계 (직접 초대한 B): B가 충전(법정화폐 또는 기타 토큰, 최소 충전금액 충족)을 완료하면, 시스템은 충전액의 1%(아래 수익 규칙 참조)를 A에게 커미션으로 지급합니다.</p><p>2단계 (B가 초대한 C): C가 충전 완료 시, A는 C 충전액의 0.5% 커미션을 받습니다.</p><p>3단계 (C가 초대한 D): D가 충전 완료 시, A는 D 충전액의 0.3% 커미션을 받습니다(더 낮은 비율).</p><p>3단계 커미션만 지원하며, 초과 단계 충전은 A의 커미션에 포함되지 않습니다.</p><p><br></p><p><strong>충전 경로 및 최소 금액：</strong></p><p><br></p><p>플랫폼에서 지원하는 모든 충전 경로(법정화폐 충전 또는 다중 네트워크 암호화폐 충전)를 지원하지만, 단일 충전은 최소 1000 USD 상당 이상이어야 커미션 산정에 포함됩니다.</p><p><br></p><p><strong>커미션 비율</strong></p><p><br></p><p>1단계 B 1.0% 예: B가 1000 USD 충전 시 A는 10 USD 수령</p><p>2단계 C 0.5% 예: C가 1000 USD 충전 시 A는 5 USD 수령</p><p>3단계 D 0.3% 예: D가 1000 USD 충전 시 A는 3 USD 수령</p><p><br></p><p><strong>커미션 지급 방식</strong></p><p><br></p><p>하위가 충전 완료 및 자금 입금 후 24시간 내에 해당 커미션을 자동으로 초대한 A의 거래 계좌에 지급합니다;</p><p>사용자는 “내 지갑” → “커미션 내역”에서 각 커미션 출처, 금액 및 지급 시간을 확인할 수 있습니다.</p><p><br></p><p><strong>5. 운영 예시</strong></p><p><br></p><p>A가 앱에 로그인 → “개인 페이지” → “친구 초대” → 전용 초대 링크/초대 코드를 복사합니다.</p><p>A는 추천 링크/초대 코드를 B에게 제공합니다.</p><p>B는 신규 등록 → 실명 인증 완료 → 최소 1000 USD 충전</p><p>충전 완료 후, 시스템은 자동으로 계산: B 충전 총액 × 1% = A 커미션. 24시간 내에 커미션은 A의 활동 계좌에 지급됩니다.</p><p><br></p><p>B가 초대한 C가 충전하면, 시스템은 B와 A 두 단계 커미션을 자동으로 계산:</p><p>B는 C 충전액 × 1% 수령;</p><p>A는 C 충전액 × 0.5% 수령;</p><p><br></p><p>C가 초대한 D가 충전하면 3단계 커미션 발생:</p><p>C는 D 충전액 × 1%;</p><p>B는 D 충전액 × 0.5%;</p><p>A는 D 충전액 × 0.3%;</p><p><br></p><p><strong>6. 리스크 관리 및 주의사항</strong></p><p><br></p><p><strong>악의적 차익거래 방지</strong></p><p><br></p><p>동일 사용자는 자기 계좌와 순환 충전 불가; 플랫폼은 비정상 소액 다중 충전, 단시간 내 대량 충전 및 출금 행위를 로그 및 리스크 감지하며, 필요시 수동 심사 후 커미션 취소;</p><p>충전 후 빠른 출금 및 고빈도 조작 특징이 있는 사용자는 악의적 차익거래로 간주하고 관련 커미션 취소;</p><p><br></p><p><strong>규정 준수 심사</strong></p><p><br></p><p>시스템 또는 백엔드 리스크 감지에서 초대받은 사람이 자금 세탁, 현금화 위험이 있다고 판단되면, 플랫폼은 해당 사용자 및 관련 체인 모든 커미션을 동결하며 규제 당국에 보고할 권리를 보유합니다.</p><p><br></p><p><br></p>',
        authRewardTxt: '<p><strong>실명 인증 시 즉시 50 USD 지급</strong></p><p><br></p><p>1. 활동 목표</p><p><br></p><p>대상 사용자: 플랫폼 신규 등록 사용자 및 이전에 실명 인증을 완료하지 않은 기존 사용자 모두 참여 가능하며, 신규 사용자가 실명 인증을 완료하도록 유도하여 사용자 유지율을 높이고자 합니다.</p><p>핵심 요구: 현금 보상 지급을 통해 실명 인증 단계를 직관적으로 자극하여 리스크 관리 품질 및 KYC 커버리지를 향상시키고 플랫폼의 합법적 운영을 보장합니다.</p><p><br></p><p>2. 활동 기간</p><p><br></p><p>2023년 5월 20일부터 장기 유효</p><p><br></p><p>3. 참여 대상</p><p><br></p><p>신규 사용자: cryptorix 플랫폼에 처음 등록하고 활동 기간 내에 실명 인증 완료한 사용자</p><p>기존 사용자: 활동 시작 전 등록했으나 아직 실명 인증을 완료하지 않은 사용자로, 활동 기간 내 실명 인증 완료 시 보상을 받습니다.</p><p><br></p><p>4. 참여 규칙</p><p><br></p><p>실명 인증 요구 사항</p><p>사용자는 신분증(주민등록증/여권/운전면허증 등) 앞뒤 사진 및 본인 신분증 반신 사진을 제출해야 합니다;</p><p>얼굴 인식 검증은 충분한 조명과 얼굴 가림 없음이 보장되어야 하며, 플랫폼의 생체 인증 요구 사항에 부합해야 합니다;</p><p>제출 후 일반 심사 시간은 24시간 내 완료됩니다.</p><p><br></p><p>보상 금액</p><p>활동 기간 내 실명 인증을 성공적으로 완료한 모든 사용자(신규 및 기존 사용자 포함)는 50 USD를 받습니다.</p><p><br></p><p>수령 방법 및 지급 시간</p><p>사용자가 실명 인증을 통과하면 시스템은 24시간 내에 50 USD를 법정화폐 계약 계좌로 입금하며, 10회의 정상 거래 완료 후 인출이 가능합니다.</p><p><br></p><p>자료 미비 또는 심사 미통과 시, 사용자는 시스템 안내에 따라 자료를 보완하여 재심사를 받아야 하며, 심사 통과 후 보상을 받을 수 있습니다.</p><p><br></p><p>5. 운영 예시</p><p><br></p><p>사용자 로그인</p><p>앱 → “실명 인증” → 실명 인증 절차 시작</p><p>신분증(주민등록증/여권/운전면허증) 앞뒤 사진 업로드</p><p>시스템이 신분증 정보를 자동 비교하며, 미통과 시 재촬영 요청</p><p>심사 통과 후 시스템은 24시간 내 50 USD 보상을 “법정화폐 계약 계좌”로 지급</p><p><br></p><p>6. 리스크 관리 및 주의사항</p><p><br></p><p>사기 방지</p><p>동일 신분증은 한 번만 보상 수령 가능; 동일 IP, 동일 기기 번호로 다중 신분증 신청 시 시스템이 리스크 제한을 트리거하며, 수동 심사 또는 거절 처리</p><p>명백한 위조, 조작 또는 포토샵 된 신분증 사진 발견 시 즉시 거절 및 계정 동결</p><p><br></p><p>자료 개인정보 보호</p><p>플랫폼은 모든 신분증 및 얼굴 인식 데이터를 합법적 리스크 관리 및 KYC 심사에만 사용하며, 사용자 허가 없이 외부 유출하지 않습니다;</p><p>심사 완료 후, 사용자가 업로드한 신분증 사진 및 영상은 관련 법률 및 규정에 따라 암호화 저장되며, 규제 요구 사항을 충족합니다.</p><p><br></p><p><br></p><p>&nbsp;</p>',
    },
    bill: {
        title: '자금 내역',
        audit: '심사 중',
        success: '성공',
        refuse: '거부됨',
        recharge: '충전',
        recharge_currency: '코인 충전',
        recharge_legal: '법정화폐 입금',
        withdrawal: '출금',
        withdrawal_currency: '코인 출금',
        cancel_withdrawal_currency: '코인 출금 취소',
        withdrawal_legal: '법정화폐 출금',
        cancel_withdrawal_legal: '법정화폐 출금 취소',
        transfer: '이체',
        usdt_contract_wallet: 'USDT 계약 → 지갑',
        legal_contract_wallet: '법정화폐 계약 → 지갑',
        coin_currency_wallet: '현물 → 지갑',
        wallet_usdt_contract: '지갑 → USDT 계약',
        wallet_legal_contract: '지갑 → 법정화폐 계약',
        wallet_coin_currency: '지갑 → 현물',
        finance_wallet: '재테크 → 지갑',
        wallet_finance: '지갑 → 재테크',
        usdt_contract_currency: 'USDT 계약→ 현물',
        finance_currency: '재테크 → 현물',
        currency_usdt_contract: '현물 → USDT 계약',
        currency_finance: '현물 → 재테크',
        legal_contract_currency: '법정화폐 계약→ 현물',
        currency_legal_contract: '현물 → 법정화폐 계약',
        recharge_reward: '하위 사용자 충전 커미션',
        auth_reward: '실명 인증 보상',
        flashcash: '빠른 교환',
        trade: '거래',
        create_order: '주문 생성',
        settlement_order: '주문 정산',
        cancel_order: '주문 취소',
        finance_return: '원금 반환',
        finance_income: '투자 수익',
        other: '기타',
        commission_transfer: '커미션 입금',
        platform_gift: '플랫폼 지급',
        system_regulation: '잔액 변동',
        freeze_thaw: '동결 해제',
        c2c_create_order: 'C2C주문 생성',
        c2c_cancel_order: 'C2C주문 취소',
        Currency: '통화',
        type: '유형',
        SelectCurrency: '통화 선택',
        SelectType: '유형 선택',
        SelectDate: '날짜 선택',
        to: '까지',
        Contractfunds: '계약 자금',
        Spotfunds: '현물 자금',
        Walletfunds: '지갑 자금',
        RechargeRecord: '충전 기록',
        WithdrawalRecord: '출금 기록',
        virtualcoin: '암호화폐',
        Legaltender: '법정화폐',
    },
    c2c: {
        limit: '한도',
        available: '사용 가능',
        price: '단가',
        needpay: '지불해야 할 금액',
        willreceive: '받을 금액',
        Insufficientlimit: '한도 부족',
        Exceedinglimit: '한도 초과',
        Exceedingavailable: '사용 가능 수량 초과',
        balance: '잔액',
        InsufficientBalance: '잔액 부족',
        OrderHistory: '주문 내역',
        quantity: '수량',
        amountmoney: '금액',
        OrderNo: '주문 번호',
        inprogress: '진행 중',
        Completed: '완료됨',
        Cancelled: '취소됨',
        all: '전체',
        chat: '채팅',
        picture: '[사진]',
        Read: '읽음',
        Unread: '읽지 않음',
        inputTips: '여기에 메시지를 입력하세요',
        send: '보내기',
    },
    common: {
        title: '모든 기능',
        Depositcoins: '코인 충전',
        Rechargefiatcurrency: '법정화폐 입금',
        Withdraw: '출금',
        documentation: '카피트레이딩',
        Activecenter: '이벤트 센터',
        Invitationforrebate: '추천 보상',
        Detailsoffunds: '자금 내역',
        Positiondetails: '포지션 내역',
        Notice: '정보',
        Aboutus: '회사소개',
        helpcenter: '도움말 센터',
        customer: '고객센터',
        Cryptocurrencywithdrawal: '암호화폐 출금',
        Fiatmoneywithdrawal: '법정화폐 출금',
        DepositcoinsTips: '간단한 절차로 빠르게 코인 구매',
        RechargefiatcurrencyTips: '법정 화폐 채널을 통해 USD 충전',
        USDTcontractTips: 'USDT로 정산되는 다양한 계약',
        FiatcurrencycontractTips: '법정 화폐로 정산되는 다양한 계약',
        TransferTips: '클릭 한 번으로 다른 암호화폐 자산으로 교환',
        c2cTips: '유연한 결제 방식 0 수수료 거래를 통한 암호화 화폐 매매',
    },
    forgotPass: {
        title: '비밀번호 재설정',
        btn: '확인',
        Password: '새 비밀번호',
        placeholder: '새 비밀번호 입력',
        success: '설정 성공',
    },
    finance: {
        financeAssetAmount: '금융 자산 평가액',
        financeAccount: '금융 계좌',
        financefund: '금융 자금',
        financeProduct: '금융 상품',
        Applynow: '지금 신청하기',
        term: '기간',
        investment: '투자 금액',
        Mininvestment: '최소 투자 금액',
        Maxinvestment: '최대 투자 금액',
        buyNum: '구매 횟수',
        Myincome: '나의 수익',
        Dailyearnings: '일일 수익',
        yieldmaturity: '만기 수익',
        timeaxis: '타임라인',
        Subscriptiondate: '신청일',
        valuedate: '이자 시작일',
        duedate: '만기일',
        Receiptdate: '입금일',
        day: '일',
        financeOrderList: '금융 기록',
        interestrate: '이율',
        Revenueamount: '수익 금액',
        Settlementamount: '정산 금액',
        regularly: '정기',
        eecurrent: '자유입출금',
        redemption: '상환',
        redemptionTips: '해당 금융 상품을 상환하시겠습니까',
        loan: '대출',
        LoanRange: '대출 범위',
        LoanAmount: '대출 금액',
        loanTerm: '대출 기간',
        Dailyinterestrate: '일일 이자율',
        Totalinterest: '총 이자',
        Repaymentmethod: '상환 방식',
        Repaymentofmaturity: '만기 일시 상환',
        Estimatedreturn: '예상 상환 금액',
        Ihavereadandagree: '읽고 동의했습니다',
        LoanAgreement: '대출 계약',
        Immediatelymoney: '즉시 대출',
        Minimumloanamount: '최소 대출 금액',
        Maximumloanamount: '최대 대출 금액',
        Applicationsuccessfulreview: '신청이 성공적으로 접수되었습니다. 시스템 심사를 기다려주세요',
        Loanrecords: '대출 기록',
        Pendingreview: '심사 대기',
        issued: '지급 완료',
        Repaid: '상환 완료',
        Rejected: '거절됨',
        LoanDate: '대출일',
        AmountDue: '상환 금액',
        repayment: '상환',
        loanTTips: '빠른 입금, 여러 가지 담보 기간 선택 가능',
        homeAddress: '상세한 집 주소',
        homeAddressTips: '상세한 집 주소를 입력하세요',
        emergencyContact: '비상 연락처',
        emergencyContactTips: '비상 연락처를 입력하세요',
        emergencyPhone: '비상 연락처 휴대전화 번호',
        emergencyPhoneTips: '비상 연락처 휴대전화 번호를 입력하세요',
        emergencyEmail: '비상 연락처 이메일',
        emergencyEmailTips: '비상 연락처 이메일을 입력하세요',
        isHouse: '본인 소유의 부동산이 있습니까',
        houseImg: '부동산이 있는 경우 소유 증명 이미지를 제공하세요',
        certImg: '증명서 앞면 (신분증/여권/운전면허증)',
        certImgTips: '증명서 앞면을 업로드하세요 (신분증/여권/운전면허증)',
        certBackImg: '증명서 뒷면 (신분증/여권/운전면허증)',
        certBackImgTips: '증명서 뒷면을 업로드하세요 (신분증/여권/운전면허증)',
        trustImg: '신용 점수 스크린샷',
        trustImgTips: '신용 점수 스크린샷을 업로드하세요',
        yesTxt: '예',
        noTxt: '아니요',
        EstimatedReturn: '예상 수익',
        seeDetail: '자세히 보기',
        orderDetails: '주문 상세',
    },
    heel: {
        tips: '곧 출시 예정~',
    },
    home: {
        optional: '선택',
        HotList: '인기 순위',
        more: '더보기',
        Capturetrading: '거래 기회 포착',
        Exploreproducts: '우리의 제품 탐색',
        Contracttrading: '선물 거래',
        Spottrading: '재테크',
        ContracttradingTips: '인기 있는 레버리지 파생상품, 최대 100배 레버리지 지원. 롱과 숏 포지션을 지원하며, 변동성이 있는 한 수익 기회가 있습니다.',
        SpottradingTips: '최소 비용, 최대 수익. 언제 어디서나 거래 시작. ',
        starttrading: '거래 시작',
        Tradeanytime: '언제 어디서나 거래',
        Scandownload: '스캔하여 다운로드',
        hundredmillion: '억',
        thousand: '만',
        year: '년',
        transactionvolume: '24시간 거래량',
        openinterest: '24시간 미결제약정',
        RegisteredUser: '등록 사용자',
        Ensuresafetyfunds: '자금 안전 보장',
        Reasonschoosingus: '우리를 선택하는 이유',
        mobeginwith: '설립 연도',
        Topliquidity: '최고의 유동성',
        Effectivelyusers: '사용자 권익 보호',
        TradeNow: '지금 거래하기',
        Needhelp: '도움이 필요하신가요',
        helpcenter: '도움말 센터',
        helpcenterTips: '자주 묻는 질문에 대한 도움을 제공하며 특정 기능에 대한 자세한 설명을 확인할 수 있습니다.',
        Learnmore: '더 알아보기',
        Onlinecustomerservice: '온라인 고객 지원',
        OnlinecustomerserviceTips: '24/7 고객 지원 제공, 언제 어디서나 이용 가능',
        PlatformAnnouncement: '플랫폼 공지',
        PlatformAnnouncementTips: '최신 정보를 제공하여 실시간 거래 정보를 빠르게 확인하세요.',
        Starttradingnow: '지금 바로 암호화폐 거래를 시작하세요!',
        Trademillions: '수백만 사용자가 신뢰하는 플랫폼에서 거래하세요',
        Storingbuyingcoins: '충전 또는 코인 구매',
        product: '제품',
        service: '서비스',
        guide: '가이드',
        agreedannouncement: '약관 및 공지',
        customerservice: '고객 서비스',
        Riskstatement: '위험 고지: 디지털 자산 거래는 신흥 산업으로 밝은 전망을 가지고 있지만, 새로운 분야이기 때문에 높은 위험이 따릅니다. 특히 레버리지 거래에서는 레버리지 배율이 수익뿐만 아니라 위험도 함께 확대시킵니다. 따라서 업계, 레버리지 거래 방식, 거래 규칙 등에 대해 충분히 이해한 후 참여하시길 바랍니다. 또한 본인이 감당할 수 있는 위험 범위 내에서 거래할 것을 강력히 권장합니다. 거래에는 위험이 따르므로 신중하게 접근하세요!',
        topTips: '하나의 계정, 무한 가능',
        coin: '현물 거래',
        coinTips: '즉시 실행, 투명한 공개, 언제 어디서나 현물 거래 여정을 시작하세요',
    },
    login: {
        title: '로그인',
        Account: '계정',
        Password: '비밀번호',
        btn: '로그인',
        placeholder: '전화번호 입력',
        placeholder1: '비밀번호 입력',
        ForgotPassword: '비밀번호 찾기',
        noAccount: '계정 없음?',
        Registration: '회원가입',
        server: '고객센터',
        success: '로그인 성공',
        checkedAgree: '개인정보 보호정책에 동의하세요',
        rememberpassword: '비밀번호 저장',
        agreewith: '동의',
        PrivacyAgreement: '개인정보 보호정책',
    },
    market: {
        product: '상품',
        Latestprice: '최신 가격',
        volume: '거래량',
        ChangeRatio: '변동률',
        Addoptional: '관심 추가',
        optional: '관심종목',
        market: '시장',
        Editselfselection: '관심종목 편집',
        operate: '작업',
        SelectAll: '전체 선택',
        delete: '삭제',
        time: '시간',
    },
    position: {
        title: '보유 내역',
        totalassets: '총 자산',
        profitloss: '손익',
        Holdingassets: '보유 자산',
        margin: '보증금',
        orderAmount: '주문 금액',
        availableassets: '사용 가능 자산',
        product: '상품',
        direction: '방향',
        Entrustedprice: '주문 가격',
        Entrustednum: '주문 수량',
        Currentprice: '현재 가격',
        Stoplossprice: '손절가',
        stopSurplusPrice: '이익 실현 가격',
        Leverageratio: '레버리지 배율',
        Entrustedtime: '주문 시간',
        orderno: '주문 번호',
        marketvalue: '시가 총액',
        SettlementPrice: '결제 가격',
        Settlementtime: '결제 시간',
        Settakeprofitloss: '손익 설정',
        closeposition: '포지션 청산',
        Position: '현재 주문',
        commission: '과거 주문',
        Settlement: '과거 체결',
        Settingsuccessful: '설정 성공',
        Confirmclosingorder: '이 주문을 청산하시겠습니까?',
        Closingsuccessfully: '청산 성공',
        cancelorder: '이 주문을 취소하시겠습니까?',
        Cancelsuccessfully: '취소 성공',
        status: '상태',
        changeRate: '수수료',
    },
    property: {
        title: '자산 내역',
        totalassets: '총 자산',
        profitloss: '손익',
        Holdingassets: '보유 자산',
        margin: '보증금',
        availableassets: '사용 가능 자산',
        investmentportfolio: '투자 포트폴리오',
        Recentincomesituation: '최근 수익 상황',
        Seemore: '더 보기',
        IncomeDetails: '수익 내역',
    },
    recharge: {
        mixAmount: '최소 충전 금액',
        subMsg: '제출 성공, 검토를 기다려 주세요',
        amountMsg: '금액을 입력하세요',
        VoucherMsg: '결제 증빙을 업로드하세요',
        Depositcoins: '코인 충전',
        Rechargecurrency: '충전 코인 종류',
        RechargecurrencyTips: '충전 금액이 200USDT 이상이면 빠른 입금 가능',
        Depositaddress: '충전 주소',
        Rechargetoaccount: '충전 입금',
        Walletaccount: '지갑 계좌',
        Rechargequantity: '충전 수량',
        Paymentvoucher: '결제 증빙',
        Youneedtorecharge: '충전해야 할 금액',
        Rechargenow: '즉시 충전',
        Rechargefiatcurrency: '법정화폐 입금',
        Topupfiatcurrency: '법정화폐 충전',
        paymentcurrency: '결제 통화',
        paymentcurrencyTips: '충전 금액이 200USD 이상이면 빠른 입금 가능',
        Fiatcontractaccount: '법정화폐 계약 계좌',
        Rechargeamount: '충전 금액',
        Youwillget: '받을 금액',
        network: '네트워크',
        notsupportedAddress: '현재 주소는 지원되지 않습니다',
        selectaccount: '계정을 선택하세요',
    },
    register: {
        title: '회원가입',
        send: '인증 코드 보내기',
        Resend: '재전송',
        sendSuccess: '전송 성공',
        PhoneNumber: '휴대폰 번호',
        Mailbox: '이메일',
        Captcha: '인증 코드',
        Password: '비밀번호',
        ConfirmPassword: '비밀번호 확인',
        PromoteCode: '추천 코드',
        OrgCode: '기관 코드',
        btn: '회원가입',
        placeholder0: '휴대폰 번호를 입력하세요',
        placeholder1: '비밀번호를 입력하세요',
        placeholder2: '비밀번호를 다시 입력하세요',
        placeholder3: '추천인 ID를 입력하세요',
        placeholder4: '인증 코드를 입력하세요',
        placeholder5: '이메일을 입력하세요',
        emaiError: '이메일 형식이 올바르지 않습니다',
        success: '회원가입 성공',
        message: '비밀번호는 최소 6자리 이상이어야 합니다',
        message1: '비밀번호 확인은 최소 6자리 이상이어야 합니다',
        message2: '비밀번호가 일치하지 않습니다',
        searchCountryMsg: '국가 또는 지역번호를 검색하세요',
        haveAccount: '이미 계정이 있으신가요?',
        goLogin: '로그인',
        titleTips: '회원가입을 시작하세요!',
        Invitationcode: '초대 코드',
        Iagreewith: '계정을 생성하면 의 약관에 동의하는 것으로 간주됩니다',
        and: '및',
    },
    safe: {
        SecuritySettings: '보안 설정',
        Accountsecurity: '계정 보안',
        phone: '휴대폰',
        Notyetbound: '미연결',
        mailbox: '이메일',
        Loginpassword: '로그인 비밀번호',
        Fundcode: '자금 비밀번호',
        Settings: '설정',
        Withdrawaladdressmanagement: '출금 주소 관리',
        Addwithdrawaladdress: '출금 주소 추가',
        Withdrawalcurrency: '출금 통화',
        Withdrawaladdress: '출금 주소',
        WithdrawaladdressTips: '출금 주소를 입력하세요',
        remark: '비고',
        confirm: '확인',
        Addedsuccessfully: '추가 성공',
        Pleaseselectcurrency: '통화를 선택하세요',
        Bindmailbox: '이메일 연결',
        Bindmobilephone: '휴대폰 번호 연결',
        ChangeLoginPassword: '로그인 비밀번호 변경',
        Setfundpassword: '자금 비밀번호 설정',
        BindmailboxTips: '이메일을 먼저 연결하세요. 연결하시겠습니까?',
        Addnewaddress: '새 주소 추가',
        Confirmdeleteaddress: '이 출금 주소를 삭제하시겠습니까?',
    },
    share: {
        title: '공유하고 수익 얻기',
        commission: '커미션',
        Commissionrecord: '커미션 내역',
        Commissiontransferout: '커미션 이체',
        Transferoutrecord: '이체 내역',
        Invitefriends: '친구 초대',
        Invitationrecord: '초대 내역',
        Commissioncommission: '커미션 비율',
        ReferralCode: '추천 코드',
        Firstlevelmembers: '1단계 회원',
        Secondlevelmembers: '2단계 회원',
        Thirdlevelmembers: '3단계 회원',
        Transferbalance: '잔액으로 이체',
        Confirmtransferout: '이체 확인',
        Transfersuccessful: '이체 성공',
        amount: '이체 금액',
        Transferfiaaccount: '법정화폐 계약 계좌로 이체',
    },
    trade: {
        high: '24h 최고가',
        low: '24h 최저가',
        vol: '24h 거래량',
        buy: '매수',
        sell: '매도',
        buyBtn: '매수하기',
        sellBtn: '매도하기',
        Present: '시장가 주문',
        Limit: '지정가 주문',
        limitMsg: '가격',
        markPriceMsg: '현재 최적가 기준',
        num: '수량',
        zyzsSet: '손익 설정',
        zyPrice: '이익 실현',
        zsPrice: '손절가',
        smallMin: 'M',
        hour: 'H',
        dayMin: 'D',
        Position: '보유 포지션',
        Viewalltransactions: '전체 거래 내역 보기',
        product: '상품',
        direction: '방향',
        Entrustedprice: '주문 가격',
        Entrustednum: '주문 수량',
        Latestprice: '최신 가격',
        volume: '체결량',
        ChangeRatio: '등락률',
        buyBtnConfirm: '매수 확인',
        sellBtnConfirm: '매도 확인',
        totalAmount: '금액',
        Margin: '증거금',
        balance: '사용 가능',
        buyLimtMsg: '매수는 시장가보다 낮은 가격만 입력할 수 있습니다',
        sellLimtMsg: '매도는 시장가보다 높은 가격만 입력할 수 있습니다',
        putNummsg: '수량을 입력하세요',
        putLimitPriceMsg: '지정가를 입력하세요',
        pleaseAuth: '실명 인증을 먼저 완료하세요',
        orderSuccess: '거래 성공',
        Fullwarehouse: '전체 포지션',
        corkado: '매수 가능',
        Kato: '매수',
        openable: '매도 가능',
        Openempty: '매도',
        purchasable: '구매 가능',
        vendibility: '판매 가능',
        Orderconfirmation: '주문 확인',
        Averageopeningprice: '평균 진입 가격',
        Marketprice: '시장가',
        Openingquantity: '진입 수량',
        Stoplossprice: '손절가',
        stopSurplusPrice: '이익 실현가',
        Averageprice: '평균 가격',
        buyLimtMsg2: '매수는 시장가보다 낮은 가격만 입력할 수 있습니다',
        sellLimtMsg2: '매도는 시장가보다 높은 가격만 입력할 수 있습니다',
        authTips: '실명 인증을 먼저 완료하세요. 인증하기',
        profundity: '시장 깊이',
        deal: '체결',
        contract: '계약',
        TradeNow: '즉시 거래',
        CloseTime: '휴장',
        buyUp: '매수 상승',
        buyDown: '매수 하락',
        selectSeconds: '만료 시간 선택',
        buyNums: '구매 금액',
        minbuyNums: '최소 구매',
        incomeRates: '수익률',
        buySuccessTips: '구매 성공',
        secondNums: '초',
        simulatedTrading: '모의 거래',
    },
    upPassword: {
        title: '비밀번호 변경',
        oldPassword: '기존 비밀번호',
        oldPasswordMsg: '기존 비밀번호를 입력하세요',
        newPassword: '새 비밀번호',
        newPasswordMsg: '새 비밀번호를 입력하세요',
        twoPassword: '비밀번호 확인',
        twoPasswordMsg: '비밀번호를 다시 입력하세요',
        twoinputMsg: '입력한 두 비밀번호가 일치하지 않습니다',
        passwordTypeMsg: '비밀번호는 숫자 6자리여야 합니다',
        submsg: '변경 성공',
        btn: '변경 확인',
    },
    user: {
        Avatarchange: '프로필 사진 변경',
        Replacesuccessfully: '변경 성공',
        authenticated: '인증 완료',
        Notcertifiedyet: '미인증',
        Invitefriends: '친구 초대',
        Activecenter: '이벤트 센터',
        Identityauthentication: '신원 인증',
        Completedverification: '인증 완료',
        Tobeverified: '인증 대기',
        SecuritySettings: '보안 설정',
        Lang: '언어 선택',
        changeTheme: '테마 변경',
        helpcenter: '고객 센터',
        Aboutus: '회사 소개',
        out: '로그아웃',
        outmsg: '로그아웃을 확인하시겠습니까?',
        trustscore: '신용 점수',
    },
    welcome: {
        title1: '업계 최고의 시장 유동성',
        tips1: '99%의 주문이 최적의 가격으로 체결됩니다',
        title2: '12년간의 신뢰',
        tips2: '언제 어디서나 신뢰할 수 있는 플랫폼에서 암호화폐를 거래하세요',
        title3: 'VIP 전용 혜택',
        tips3: 'VIP 회원이 되어 거래, 환전, 출금 수수료 할인을 받으세요',
        title4: '100,000USDT 모의 거래금',
        tips4: '위험 없이 거래 연습하기',
        bnt1: '가입 즉시 10 USDT 지급',
        bnt2: '로그인',
    },
    with: {
        Withdrawcurrency: '출금',
        currencyofwithdrawal: '출금 통화',
        Withdrawaladdress: '출금 주소',
        Addwithdrawaladdress: '출금 주소 추가',
        Withdrawalquantity: '출금 수량',
        availablebalance: '사용 가능 잔액',
        WithdrawaladdressTips: '이 통화에 대한 출금 주소가 설정되지 않았습니다. 설정하시겠습니까?',
        selectWithdrawaladdress: '출금 주소를 선택하세요',
        Insufficientavailablebalance: '사용 가능 잔액 부족',
        Withdrawingfiatcurrency: '법정화폐 출금',
        Withdrawaloffiatcurrency: '출금 법정화폐',
        Currentbalance: '현재 잔액',
        Currencyreceived: '입금 통화',
        WithdrawingfiatcurrencyTips: '출금 금액이 200USD 이상이면 빠르게 입금됩니다',
        Withdrawalaccount: '출금 계좌',
        Fiatcontractaccount: '법정화폐 계약 계좌',
        Withdrawalamount: '출금 금액',
        Youneedwithdrawmoney: '출금해야 할 금액',
        Youwillget: '입금될 금액',
        Withdrawimmediately: '즉시 출금',
        mixAmount: '최소 출금 금액 ',
        subMsg: '제출 성공, 검토를 기다려 주세요',
    },
}